import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-w-panels" }

import {
  PieChart01,
  TypeSquare,
  Phone,
  Microphone01,
  Image03,
  PieChart02,
  Trash01,
  Edit02,
  Clock,
  PhoneHangUp,
} from "utruckin-icons";

import CustomPanel from "@/components/custom/CustomPanel.vue";
import {useStatsStore} from "@/features/stats/stats.store";
import {ICountFilter, IFilter} from "@/types/main";
import {computed, onMounted, ref, watch} from "vue";
import {useErrorStore} from "@/features/errors/errors.store";

interface IProps {
  filter: IFilter;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'errorPanel',
  props: {
    filter: {}
  },
  setup(__props: any) {

const store = useStatsStore();
const errorStore = useErrorStore();

const loading = ref<boolean>(false);
const data = ref()


const props = __props;

const countFilter = computed(() => {
  if (props.filter) {
    return {
      account_id: props.filter.account,
      time_from: props.filter.time_from,
      time_to: props.filter.time_to,
      date_from: props.filter.date_from,
      date_to: props.filter.date_to,
      shift_id: props.filter.shift,
    }
  }
})

const getInfo = async () => {
  data.value = await store.getStats(countFilter.value as ICountFilter, loading);
}

const info = computed(() => {
  const source = data.value

  return {
    errors: {
      total: source?.errors?.total ?? 0,
      reply_time: source?.errors?.reply_time_exceed ?? 0,
      deleted: source?.errors?.deleted ?? 0,
      edited: source?.errors?.edited ?? 0,
      unanswered:
          (source?.errors?.declined_calls ?? 0) +
          (source?.errors?.missed_calls ?? 0),
    }
  };
});

watch(
    () => JSON.stringify(countFilter.value),
    () => {
      getInfo()
    },
    {immediate: true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomPanel, {
      icon: _unref(PieChart02),
      number: info.value.errors.total,
      type: "error",
      label: "All errors",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(errorStore).selectPanel('allErrors'))),
      "is-active": _unref(errorStore).panels.allErrors
    }, null, 8, ["icon", "number", "is-active"]),
    _createVNode(CustomPanel, {
      icon: _unref(Trash01),
      number: info.value.errors.reply_time,
      type: "error",
      label: "Reply time",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(errorStore).selectPanel('replyTime'))),
      "is-active": _unref(errorStore).panels.replyTime
    }, null, 8, ["icon", "number", "is-active"]),
    _createVNode(CustomPanel, {
      icon: _unref(Edit02),
      number: info.value.errors.unanswered,
      type: "error",
      label: "Unanswered",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(errorStore).selectPanel('unanswered'))),
      "is-active": _unref(errorStore).panels.unanswered
    }, null, 8, ["icon", "number", "is-active"]),
    _createVNode(CustomPanel, {
      icon: _unref(Clock),
      number: info.value.errors.deleted,
      type: "error",
      label: "Deleted",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(errorStore).selectPanel('deleted'))),
      "is-active": _unref(errorStore).panels.deleted
    }, null, 8, ["icon", "number", "is-active"]),
    _createVNode(CustomPanel, {
      icon: _unref(PhoneHangUp),
      number: info.value.errors.edited,
      type: "error",
      label: "Edited",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(errorStore).selectPanel('edited'))),
      "is-active": _unref(errorStore).panels.edited
    }, null, 8, ["icon", "number", "is-active"])
  ]))
}
}

})